import {markupFormatter} from "../../common";
import {getPlainText} from "../../common/utils/getPlainText";

export function regenerateSeedFromMarkup(markup: string | undefined): string {
    if (markup === undefined) return '';

    const tree = markupFormatter.parse(markup);
    const isInverted = tree.tags.some(tag => tag.toLowerCase() === 'inverted');

    return isInverted
        ? getPlainText(tree.question).trim()
        : getPlainText(tree.answer).split(',')[0].trim();
}
